(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beyond-featured-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('beyond-release-tiles'))customElements.define('beyond-release-tiles',class extends HTMLElement{
 connectedCallback(){
  this.controller=new AbortController();const signal=this.controller.signal;this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.paused=false;this.button=this.querySelector('.brt-pause');
  this.panels=[...this.querySelectorAll('[data-panel]')].map((root,i)=>({root,slides:[...root.querySelectorAll('.brt-slide')],index:0,delay:6500+i*1700,timer:null}));
  this.panels.forEach(p=>{p.root.addEventListener('mouseenter',()=>this.stop(p),{signal});p.root.addEventListener('mouseleave',()=>this.start(p),{signal});p.root.addEventListener('focusin',()=>this.stop(p),{signal});p.root.addEventListener('focusout',()=>queueMicrotask(()=>this.start(p)),{signal});p.root.querySelector('.brt-next')?.addEventListener('click',()=>this.show(p,(p.index+1)%p.slides.length),{signal})});
  this.button.addEventListener('click',()=>{this.paused=!this.paused;this.dataset.paused=String(this.paused);this.button.setAttribute('aria-pressed',String(this.paused));this.button.textContent=this.paused?this.button.dataset.play:this.button.dataset.pause;this.refresh()},{signal});
  document.addEventListener('visibilitychange',()=>this.refresh(),{signal});this.motion.addEventListener('change',()=>this.refresh(),{signal});
  document.addEventListener('shopify:block:select',e=>{const p=this.panels.find(p=>p.slides.some(s=>s.contains(e.target)||s===e.target));if(p){this.show(p,p.slides.findIndex(s=>s.contains(e.target)||s===e.target));this.stop(p)}},{signal});this.refresh();
 }
 show(p,index){p.index=index;p.slides.forEach((s,i)=>{s.classList.toggle('is-active',i===index);s.setAttribute('aria-hidden',String(i!==index));s.tabIndex=i===index?0:-1})}
 stop(p){clearInterval(p.timer);p.timer=null}
 start(p){this.stop(p);if(this.paused||this.motion.matches||document.hidden||p.root.matches(':hover')||p.root.contains(document.activeElement)||p.slides.length<2)return;p.timer=setInterval(()=>this.show(p,(p.index+1)%p.slides.length),p.delay)}
 refresh(){this.panels.forEach(p=>this.start(p))}
 disconnectedCallback(){this.panels?.forEach(p=>this.stop(p));this.controller?.abort()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-brands-page"]) return;
  try {
    
  if (!customElements.get('beyond-brands-directory')) {
    customElements.define('beyond-brands-directory', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const groups = [...this.querySelectorAll('.bb-group')];
        const items = [...this.querySelectorAll('[data-brand]')];
        const input = this.querySelector('input');
        const clear = this.querySelector('.bb-clear');
        const nav = this.querySelector('.bb-alphabet');
        const status = this.querySelector('.bb-status');
        const normalise = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
        groups.forEach(group => {
          const link = document.createElement('a');
          link.href = '#' + group.id;
          link.textContent = group.dataset.letter;
          link.setAttribute('aria-label', 'Brands starting with ' + group.dataset.letter);
          nav.appendChild(link);
        });
        const update = () => {
          const query = normalise(input.value);
          let count = 0;
          items.forEach(item => {item.hidden = !normalise(item.dataset.brand).includes(query);if (!item.hidden) count++;});
          groups.forEach((group, i) => {group.hidden = ![...group.querySelectorAll('[data-brand]')].some(item => !item.hidden);nav.children[i].hidden = group.hidden;});
          status.textContent = query ? count + (count === 1 ? ' brand found' : ' brands found') : items.length + ' brands. Find your next favourite.';
          this.querySelector('.bb-empty').hidden = count !== 0;
          clear.hidden = !input.value;
        };
        input.addEventListener('input', update);
        clear.addEventListener('click', () => {input.value = '';update();input.focus();});
        this.querySelector('.bb-search').hidden = false;
        nav.hidden = false;
        status.hidden = false;
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
